import { Box, NavTab } from '@csp/csp-web-ui';
import { FC, useMemo } from 'react';
import { CspPath } from '../../../CspPath';
import { StaticContentService } from '../../../common/service/StaticContentService';
import { HeaderNavTabsComponent } from '../component/HeaderNavTabsComponent';
import { usePatientSubTabs } from '../hooks/usePatientSubTabs';
import { useSelectedNavTab } from '../hooks/useSelectedNavTab';

export const PatientNavSubTabsContainer: FC = () => {
  const navTabTexts = StaticContentService.getGenericBlock('webHcpPatientList', 'navigationTab');
  const { subNavs } = usePatientSubTabs();

  const mainSubTabs = useMemo(() => {
    const defaultNavTabs: NavTab<CspPath>[] = [
      {
        label: navTabTexts.textLabel.patients.label,
        path: CspPath.PATIENT_LIST_STANDARD,
      },
    ];

    return [...defaultNavTabs, ...subNavs];
  }, [navTabTexts.textLabel.patients.label, subNavs]);
  const selectedTab = useSelectedNavTab(mainSubTabs, CspPath.PATIENT_LIST_STANDARD);

  return subNavs.length ? (
    <>
      <Box height="0.5rem" bgcolor="transparent.grey" />
      <HeaderNavTabsComponent isSubTab tabs={mainSubTabs} selectedPath={selectedTab} />
    </>
  ) : null;
};
